import { render } from "./Category.vue?vue&type=template&id=6cec61b8&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=6cec61b8&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\cymcorp-site\\dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cec61b8"]])

export default __exports__